import { readableColor } from 'polished'
import { ButtonHTMLAttributes, forwardRef, Ref } from 'react'

import styles from './Button.module.css'

const clipDepth = 18

interface ButtonProps
  extends Pick<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'type' | 'className' | 'children' | 'disabled' | 'onClick'
  > {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'brand' | 'dark'
  wide?: boolean
  loading?: boolean
  clipSide?: 'left' | 'right'
  backgroundColor?: string
}

export const Button = forwardRef((props: ButtonProps, ref: Ref<any>) => {
  let className = styles.button
  switch (props.variant) {
    case 'primary':
      className += ` ${styles.primary}`
      break
    case 'secondary':
      className += ` ${styles.secondary}`
      break
    case 'brand':
      className += ` ${styles.brand}`
      break
    case 'tertiary':
      className += ` ${styles.tertiary}`
      break
    case 'dark':
      className += ` ${styles.dark}`
      break
    default:
      className += ` ${styles.primary}`
  }

  if (props.wide) className += ` ${styles.wide}`
  if (props.loading) className += ' animate-pulse'

  return (
    <button
      className={className}
      style={{
        ...(props.backgroundColor
          ? {
              backgroundColor: props.backgroundColor,
              color: readableColor(props.backgroundColor),
              '--tw-ring-color': props.backgroundColor
            }
          : {})
      }}
      {...props}
      ref={ref}
    />
  )
})
